<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
    @closed="dialogClose"
    width="50%"
    v-loading="loading"
    element-loading-text="加载中..."
  >
    <el-card :body-style="{ padding: '0px' }">
      <div slot="header" class="clearfix">
        <span style="font-size:16px">提问内容</span>
      </div>
      <div style="padding: 14px">
        <span>{{ detialData.Content || "-" }}</span>
        <div class="card_question_bottom clearfix">
          <time class="time">发布时间：{{ detialData.CreateTime || "-" }}</time>
          <el-button type="text" class="button" icon="el-icon-view">{{
            detialData.ReadCount
          }}</el-button>
        </div>
      </div>
      <div
        style="padding: 0 14px 14px 14px; margin-top: -10px"
        v-if="permission"
      >
        <el-divider content-position="left">发送人信息</el-divider>
        <el-row>
          <el-col :span="12" class="card_question_info">
            姓名：{{ detialData.CreateUserName }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            联系电话：{{ detialData.Mobile }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            所属办事处：{{ detialData.WorkUnit }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            所属分站：{{ detialData.StationName }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            上级经理AD：{{ detialData.ManagerAdAccount }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            上级经理中文名：{{ detialData.ManagerName }}
          </el-col>
          <el-col :span="12" class="card_question_info">
            上级经理英文名：{{ detialData.ManagerEname }}
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card class="mt-20" :body-style="{ padding: '0px' }">
      <div slot="header" class="clearfix">
        <span style="font-size:16px">主席回复</span>
      </div>
      <div style="padding: 14px" v-if="!permission">
        <span>{{ detialData.Reply || "-" }}</span>
        <div class="card_question_bottom clearfix">
          <time class="time">回复时间：{{ detialData.ReplyTime || "-" }}</time>
        </div>
      </div>
      <div style="padding: 14px" v-if="permission">
        <el-form
          ref="form"
          :model="form"
          :label-width="formLabelWidth"
          v-loading="loading"
          element-loading-text="提交中..."
          size="small"
        >
          <el-form-item
            label="内容"
            prop="replytext"
            :rules="[
              { required: true, message: '内容不能为空', trigger: 'blur' },
            ]"
          >
            <el-input
              type="textarea"
              v-model="form.replytext"
              autocomplete="off"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否公开"
            prop="IsOpen"
            :rules="[{ required: true, message: '请选择', trigger: 'blur' }]"
          >
            <el-select v-model="form.IsOpen" placeholder="请选择是否公开">
              <el-option
                v-for="val in option"
                :label="val.label"
                :value="val.value"
                :key="val.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div slot="footer" class="dialog-footer" v-if="permission">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitHandle">确 定</el-button>
    </div>
    <div slot="footer" class="dialog-footer" v-else>
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as indexService from "@/api/sys/index";
export default {
  name: "listTextDetial",
  props: {
    listDetialData: Object,
    value: Boolean,
  },
  data() {
    return {
      dialogVisible: false,
      detialData: {},
      title: "",
      permission: false,
      loading: false,
      form: {
        replytext: "",
        IsOpen: 0,
      },
      option: [
        {
          // 下拉数据
          label: "否",
          value: 0,
        },
        {
          // 下拉数据
          label: "是",
          value: 1,
        },
      ],
      formLabelWidth: "80px",
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    opened() {
      return this.$store.state.d2admin.page.opened;
    },
    current() {
      return this.$store.state.d2admin.page.current;
    },
  },
  methods: {
    dialogOpen() {
      this.loading = true;
      let shortTitle = "";
      this.opened.map((v) => {
        if (v.name == this.current) {
          shortTitle = v.meta.title;
        }
      });
      if (!this.listDetialData.isRead) {
        let configID = {
          configID: this.listDetialData.configID,
        };
        indexService.IsReadListData(configID).then((data) => {
          this.getDetial(shortTitle);
          this.$emit("submit");
        });
      } else {
        this.getDetial(shortTitle);
      }
    },
    getDetial(shortTitle) {
      if (this.listDetialData.ID) {
        let parmas = {
          dataId: this.listDetialData.ID,
          detailed: false,
          fiter: "",
          shortTitle: shortTitle,
        };
        let query = {
          dataId: this.listDetialData.ID,
          templateId: this.listDetialData._TEMPLATE_ID,
        };
        // 详情
        indexService.getActiveDetialData(parmas).then((data) => {
          this.title = '标题：'+data.data.mainData.Title;
          this.detialData = data.data.mainData;
          this.form.IsOpen=this.detialData.IsOpen;
          this.loading = false;
        });
        // 权限
        indexService.getReplyPermission(query).then((data) => {
          this.permission = data.data.permission;
          this.loading = false;
        });
      } else {
        this.title = "主席信箱——详情";
        this.loading = false;
      }
    },
    submitHandle() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let form = {
            ID: this.listDetialData.ID,
            Reply: this.form.replytext,
            IsOpen: this.form.IsOpen,
          };
          indexService
            .addReplayData({
              ...form,
            })
            .then((data) => {
              this.$message.success("回复成功！");
              this.loading = false;
              this.dialogVisible = false;
              window.location.reload();
            })
            .catch((e) => {
              this.dialogVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    dialogClose() {
      this.dialogVisible = false;
      this.detialData = {};
      this.title = "主席信箱——详情";
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 5px 20px 10px 20px;

  &::-webkit-scrollbar {
    // 是否显示
    display: none;
    width: 6px;
    padding-right: 4px;
    background-color: #fff;
  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 3px;
    border-radius: 3px;
    background-color: #c6c6c6;
  }
}
.question_panel {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-bottom: 15px;
  border-top: 0;
  .question_panel_body {
    padding-top: 0;
  }
}
.card_question_bottom {
  margin-top: 13px;
  line-height: 12px;
  .time {
    font-size: 13px;
    color: #999;
  }
  .button {
    padding: 0;
    float: right;
    color: #999;
  }
}
.card_question_info {
  font-size: 12px;
  color: #666;
  line-height: 26px;
}
.mt-20 {
  margin-top: 20px;
}
</style>